var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
    _vm.$bem(),
    _vm.size ? '_size-' + _vm.size : '',
    _vm.color ? '_' + _vm.color : '',
    { _icon: _vm.icon }
  ]},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }